import { useQuery } from '@tanstack/react-query'
import { webinarsAnalyticsApi } from '../api/webinars-analytics.api'

export function useWebinarReporteGrupoFarma() {
  return useQuery({
    queryKey: ['webinars-analytics', 'grupofarma'],
    queryFn: webinarsAnalyticsApi.obtenerReporteGrupoFarma,
    staleTime: 5 * 60 * 1000,
  })
}
